import React, { useReducer, createContext, Dispatch } from 'react';
import { ActionType } from 'enums/types';

interface GlobalState {
	isCookiesWarningVisible: boolean;
	emergencyMessage: string;
	isLoginDisabled: boolean;
}

interface Action {
	type: ActionType;
	payload: GlobalState;
}

export type GlobalContext = {
	store: GlobalState;
	dispatch: Dispatch<Action>;
}

interface Props {
	children: React.ReactNode;
}

export const initialState: GlobalState = {
	isCookiesWarningVisible: false,
	emergencyMessage: "",
	isLoginDisabled: false,
};

export const reducer = (state: GlobalState, action: Action): GlobalState => {
	switch (action.type) {
		case ActionType.ShowCookies:
			return { ...state, isCookiesWarningVisible: true };
		case ActionType.HideCookies:
			return { ...state, isCookiesWarningVisible: false };
		case ActionType.SetEmergencyMessage:
			return { ...state, emergencyMessage: action.payload.emergencyMessage, isLoginDisabled: action.payload.isLoginDisabled };
		default:
			return state;
	}
};

export const StateContext = createContext<GlobalContext>({
	store: initialState,
	dispatch: () => null
});

export const Provider = ({ children }: Props) => {
	const [store, dispatch] = useReducer<React.Reducer<GlobalState, Action>>(reducer, initialState);
	return <StateContext.Provider value={{ store, dispatch }}>{children}</StateContext.Provider>;
};
